exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-link-disabled[data-v-7f3fb0ac] {\n    position: relative;\n    display: block;\n    margin-left: -1px;\n    line-height: 1.25;\n    background-color: #fff;\n    border: 1px solid #dee2e6;\n    padding: 5px 10px;\n    border-radius: 4px;\n    color: #354052;\n    font-size: 14px;\n}\n\n", ""]);

// exports
